import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

const DatePickerComponent = ({enableDates, onChange, name}) => {
    const range = (a, b) => {
        const years = [];
        for (let i = a; i <= b; i++) {
            years.push(i);
        }
        return years;
    }

    const currentYear = new Date().getFullYear();
    const [startDate, setStartDate] = useState(new Date());
    const years = range(1800, currentYear);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const handleDateChange = (date) => {
        setStartDate(date);
        onChange({ target: { name, value: date } });
    };


    return (
        <DatePicker
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <button
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                        style={{
                            border: 'none',
                            fontSize: '13px',
                            border: "none",
                            width: "32px",
                            fontWeight: 800
                        }}
                    >
                        {"<"}
                    </button>

                    <select
                        value={date.getFullYear()}
                        onChange={({ target: { value } }) => changeYear(value)}
                        style={{
                            fontSize: '13px',
                            border: 'none',
                            backgroundColor: 'transparent',
                        }}
                    >
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>

                    <select
                        value={months[date.getMonth()]}
                        onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                        }
                        style={{
                            fontSize: '13px',
                            border: 'none',
                            backgroundColor: 'transparent',
                        }}
                    >
                        {months.map((month, index) => (
                            <option key={index} value={month}>
                                {month}
                            </option>
                        ))}
                    </select>

                    <button
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                        style={{
                            border: 'none',
                            fontSize: '13px',
                            border: "none",
                            width: "32px",
                            fontWeight: 800
                        }}
                    >
                        {">"}
                    </button>
                </div>
            )}
            selected={startDate}
            maxDate={enableDates}
            showPopperArrow={false}
            onChange={handleDateChange}
            placeholderText="MM/DD/YYYY"
        />
    );
};

export default DatePickerComponent;


